import * as actionTypes from './types';

export const resetGifts = (payload) => ({
  type: actionTypes.RESET_GIFTS,
  payload
});

export const fetchGiftsByFiltersRequested = (payload) => ({
  type: actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS,
  payload
});

export const fetchGiftsByFiltersSuccess = (payload) => ({
  type: actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS_SUCCESS,
  payload
});

export const fetchGiftsByFiltersFailed = (payload) => ({
  type: actionTypes.FETCH_GIFTS_PRODUCTS_BY_FILTERS_FAILED,
  payload
});

export const setGiftsProductsParams = (payload) => ({
  type: actionTypes.SET_GIFTS_PRODUCTS_PARAMS,
  payload
});

export const setGiftsProductsPage = (payload) => ({
  type: actionTypes.SET_GIFTS_PRODUCTS_PAGE,
  payload
});

export const resetGiftsProducts = (payload) => ({
  type: actionTypes.RESET_GIFTS_PRODUCTS,
  payload
});

export const priceFilterCanBeSent = (payload) => ({
  type: actionTypes.PRICE_FILTER_CAN_BE_SENT,
  payload
});

export const fetchProductDetailsRequested = (payload) => ({
  type: actionTypes.FETCH_PRODUCT_DETAILS,
  payload
});

export const fetchProductDetailsSuccess = (payload) => ({
  type: actionTypes.FETCH_PRODUCT_DETAILS_SUCCESS,
  payload
});

export const fetchProductDetailsFailed = (payload) => ({
  type: actionTypes.FETCH_PRODUCT_DETAILS_FAILED,
  payload
});

export const fetchProductsByRecommendationsRequest = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS,
  payload
});

export const fetchProductsByRecommendationsSuccess = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS_SUCCESS,
  payload
});

export const fetchProductsOfSelectedCategoryRequested = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY,
  payload
});

export const fetchProductsOfSelectedCategorySuccess = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY_SUCCESS,
  payload
});

export const fetchProductsOfSelectedCategoryFailed = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_OF_SELECTED_CATEGORY_FAILED,
  payload
});

export const fetchProductsByRecommendationsFailed = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_BY_RECOMMENDATIONS_FAILED,
  payload
});

export const setShowRecommendations = (payload) => ({
  type: actionTypes.SET_SHOW_RECOMMENDATIONS,
  payload
});

export const setWithRecommendations = (payload) => ({
  type: actionTypes.SET_WITH_RECOMMENDATIONS,
  payload
});

export const setRecommendedCategory = (payload) => ({
  type: actionTypes.SET_RECOMMENDED_CATEGORY,
  payload
});

export const fetchDynamicConfigurationRequested = (payload) => ({
  type: actionTypes.FETCH_DYNAMIC_CONFIGURATION,
  payload
});

export const fetchDynamicConfigurationSuccess = (payload) => ({
  type: actionTypes.FETCH_DYNAMIC_CONFIGURATION_SUCCESS,
  payload
});

export const fetchDynamicConfigurationFailed = (payload) => ({
  type: actionTypes.FETCH_DYNAMIC_CONFIGURATION_FAILED,
  payload
});

export const fetchDynamicConfigurationEmpty = () => ({
  type: actionTypes.FETCH_DYNAMIC_CONFIGURATION_EMPTY
});

export const fetchProductsOfDynamicCategoryRequested = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG,
  payload
});

export const fetchProductsOfDynamicCategorySuccess = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG_SUCCESS,
  payload
});

export const fetchProductsOfDynamicCategoryFailed = (payload) => ({
  type: actionTypes.FETCH_PRODUCTS_DYNAMIC_CONFIG_FAILED,
  payload
});

export const changeRecommendationProductsPage = (payload) => ({
  type: actionTypes.CHANGE_RECOMMENDATION_PRODUCT_PAGE,
  payload
});

export const changeRecommendationProductsOrder = (payload) => ({
  type: actionTypes.CHANGE_RECOMMENDATION_PRODUCT_ORDER,
  payload
});
